import React from 'react'

import HeroCarousel, { HeroCarouselProps } from '../HeroCarousel'
import ArtisanLogoLottie from '../ArtisanLogoLottie'
import { useTranslation } from '@models/Translation'

import * as style from './style.module.sass'
import Link from '@src/components/atoms/Link'

type HeroSectionProps = HeroCarouselProps

const HeroSection: React.FC<HeroSectionProps> = ({
  artisanArticles,
  carouselIds,
}) => {
  const { t, locale } = useTranslation()

  return (
    <section className={style.section}>
      <div className={style.introduction}>
        <div className={style.logoContainer}>
          <ArtisanLogoLottie />
        </div>
        <div className={style.lead} data-en={locale === 'en'}>
          {t('artisan.hero1')}
          <br />
          {t('artisan.hero2')}
        </div>
        <Link to="/artisan/about" className={style.link}>
          About
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.38662 16.7654C12.8464 16.7654 16.4617 13.1501 16.4617 8.69034C16.4617 4.23058 12.8464 0.615234 8.38662 0.615234C3.92687 0.615234 0.311523 4.23058 0.311523 8.69034C0.311523 13.1501 3.92687 16.7654 8.38662 16.7654ZM7.93714 5.8317C7.62741 5.62521 7.22916 5.60596 6.90095 5.78161C6.57274 5.95726 6.36785 6.2993 6.36785 6.67156V10.7091C6.36785 11.0814 6.57274 11.4234 6.90095 11.5991C7.22916 11.7747 7.62741 11.7555 7.93714 11.549L10.9653 9.5302C11.2461 9.34299 11.4148 9.02783 11.4148 8.69034C11.4148 8.35284 11.2461 8.03768 10.9653 7.85048L7.93714 5.8317Z"
              fill="currentColor"
            />
          </svg>
        </Link>
        <div className={style.scroll}>SCROLL</div>
      </div>
      <div className={style.carousel}>
        <HeroCarousel
          artisanArticles={artisanArticles}
          carouselIds={carouselIds}
        />
      </div>
      <div className={style.introductionSp}>
        <div className={style.copy}>{t('artisan.overviewCopy')}</div>
        <div className={style.lead}>
          {t('artisan.hero1')}
          <br />
          {t('artisan.hero2')}
        </div>
        <Link to="/artisan/about" className={style.link}>
          About
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.38662 16.7654C12.8464 16.7654 16.4617 13.1501 16.4617 8.69034C16.4617 4.23058 12.8464 0.615234 8.38662 0.615234C3.92687 0.615234 0.311523 4.23058 0.311523 8.69034C0.311523 13.1501 3.92687 16.7654 8.38662 16.7654ZM7.93714 5.8317C7.62741 5.62521 7.22916 5.60596 6.90095 5.78161C6.57274 5.95726 6.36785 6.2993 6.36785 6.67156V10.7091C6.36785 11.0814 6.57274 11.4234 6.90095 11.5991C7.22916 11.7747 7.62741 11.7555 7.93714 11.549L10.9653 9.5302C11.2461 9.34299 11.4148 9.02783 11.4148 8.69034C11.4148 8.35284 11.2461 8.03768 10.9653 7.85048L7.93714 5.8317Z"
              fill="currentColor"
            />
          </svg>
        </Link>
      </div>
    </section>
  )
}

export default HeroSection
